/**
 * @generated SignedSource<<8c492bf97df70c8919a23ccf9fea18b0>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type usePdpEstimateSimilarSold_viewer$data = {
  readonly similarSoldItemsResults?: {
    readonly totalResults: number | null;
  } | null;
  readonly " $fragmentType": "usePdpEstimateSimilarSold_viewer";
};
export type usePdpEstimateSimilarSold_viewer$key = {
  readonly " $data"?: usePdpEstimateSimilarSold_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"usePdpEstimateSimilarSold_viewer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "isEstimateSimilarSoldVariant"
    },
    {
      "kind": "RootArgument",
      "name": "itemId"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "usePdpEstimateSimilarSold_viewer",
  "selections": [
    {
      "condition": "isEstimateSimilarSoldVariant",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "alias": "similarSoldItemsResults",
          "args": [
            {
              "kind": "Literal",
              "name": "first",
              "value": 0
            },
            {
              "kind": "Variable",
              "name": "itemId",
              "variableName": "itemId"
            }
          ],
          "concreteType": "SimilarSoldItemsConnection",
          "kind": "LinkedField",
          "name": "similarSoldItems",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "totalResults",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ]
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};

(node as any).hash = "f36354a84dcf694b304894379678910c";

export default node;
